<template>
    <mortgage-purchase-rate-table
        :credit-score-band-id-nav="creditScoreBandIdNav"
        :credit-score-tooltip="creditScoreTooltip"
        :cta-params="ctaParams"
        :current-mortgage-balance="currentMortgageBalance"
        :destination-button-text="destinationButtonText"
        :destination-link-or-id="destinationLinkOrId"
        :disclosure-text="disclosureText"
        :disclosure-tokens="disclosureTokens"
        :down-payment-nav="downPaymentNav"
        :down-payment-tooltip="downPaymentTooltip"
        :estimated-credit-score-band-id="estimatedCreditScoreBandId"
        :estimated-down-payment="estimatedDownPayment"
        :estimated-property-value="estimatedPropertyValue"
        :graph-ql-uri="graphQlUri"
        :header-text="headerText"
        :hide-adjust-criteria-cta="hideAdjustCriteriaCta"
        :hide-filters="false"
        :hide-loan-type-filter="hideLoanTypeFilter"
        :home-val-tooltip="homeValTooltip"
        :label-current-mortgage-balance="labelCurrentMortgageBalance"
        :label-estimated-credit-score-band-id="labelEstimatedCreditScoreBandId"
        :label-estimated-down-payment="labelEstimatedDownPayment"
        :label-estimated-property-value="labelEstimatedPropertyValue"
        :label-estimated-purchase-price="labelEstimatedPurchasePrice"
        :label-loan-type="labelLoanType"
        :label-property-use="labelPropertyUse"
        :loan-amount="loanAmount"
        :loan-program="loanProgram"
        :loan-tab="loanTab"
        :loan-type-nav="loanTypeNav"
        :loan-type="loanType"
        :lt-makes-money-title="ltMakesMoneyTitle"
        :lt-paid-description="ltPaidDescription"
        :lt-paid-title="ltPaidTitle"
        :mortgage-balance-nav="mortgageBalanceNav"
        :open-disclosure-modal="openDisclosureModal"
        :property-use-nav="propertyUseNav"
        :property-use="propertyUse"
        :property-value-nav="propertyValueNav"
        :show-filter="showFilter"
        :show-location="showLocation"
        :show-on-over="showOnOver"
        :show-time-stamp="normalizedShowTimeStamp"
        :show-tooltip-loader="showTooltipLoader"
        :update-rates-button-text="updateRatesButtonText"
        :hide-hdltgp="hideHdltgp"
    />
</template>

<script>
    import MortgagePurchaseRateTable from '../mortgage-purchase-rate-table/app.vue';
    import DefaultTooltip from '~/constants/tooltip-defaults';

    export default {
        components: {
            MortgagePurchaseRateTable,
        },
        props: {
            creditScoreBandIdNav: {
                default: false,
            },
            creditScoreTooltip: {
                default: DefaultTooltip.CreditScore,
            },
            ctaParams: {
                default: '',
            },
            currentMortgageBalance: {
                default: 200000,
            },
            destinationButtonText: {
                default: 'Get Free Offers',
            },
            destinationLinkOrId: {
                default: '',
            },
            disclosureText: {
                default: 'Disclosures',
            },
            disclosureTokens: {
                default: '00001,000127',
            },
            downPaymentNav: {
                default: false,
            },
            downPaymentTooltip: {
                default: DefaultTooltip.DownPayment,
            },
            estimatedCreditScoreBandId: {
                default: 'Excellent',
            },
            estimatedDownPayment: {
                default: 50000,
            },
            estimatedPropertyValue: {
                default: 250000,
            },
            graphQlUri: {
                default: '',
            },
            headerText: {
                default: '',
            },
            hideAdjustCriteriaCta: {
                default: false,
            },
            hideLoanTypeFilter: {
                default: false,
            },
            homeValTooltip: {
                default: DefaultTooltip.HomeVal,
            },
            labelCurrentMortgageBalance: {
                default: 'Mortgage Balance',
            },
            labelEstimatedCreditScoreBandId: {
                default: 'Credit Score',
            },
            labelEstimatedDownPayment: {
                default: 'Down Payment',
            },
            labelEstimatedPropertyValue: {
                default: 'Home Value',
            },
            labelEstimatedPurchasePrice: {
                default: 'Home Price',
            },
            labelLoanType: {
                default: 'Loan Type',
            },
            labelPropertyUse: {
                default: 'Property Use',
            },
            loanAmount: {
                default: 0,
            },
            loanProgram: {
                default: '',
            },
            loanTab: {
                default: '',
            },
            loanType: {
                default: 'Refinance',
            },
            loanTypeNav: {
                default: false,
            },
            ltMakesMoneyTitle: {
                default: 'How LendingTree Gets Paid',
            },
            ltPaidDescription: {
                default: 'LendingTree is compensated by companies on this site and this compensation may impact how and where offers appears on this site (such as the order). LendingTree does not include all lenders, savings products, or loan options available in the marketplace.',
            },
            ltPaidTitle: {
                default: 'How Does LendingTree Get Paid?',
            },
            mortgageBalanceNav: {
                default: false,
            },
            openDisclosureModal: {
                default: true,
            },
            propertyUse: {
                default: 'Primary Home',
            },
            propertyUseNav: {
                default: false,
            },
            propertyValueNav: {
                default: false,
            },
            showFilter: {
                default: false,
            },
            showLocation: {
                default: true,
            },
            showOnOver: {
                default: true,
            },
            showTimeStamp: {
                default: 'true',
            },
            showTooltipLoader: {
                default: false,
            },
            updateRatesButtonText: {
                default: 'Update Rates',
            },
            hideHdltgp: {
                default: false,
            },
        },
        computed: {
            normalizedShowTimeStamp() {
                if (typeof this.showTimeStamp === 'string') {
                    return this.showTimeStamp.toLowerCase() === 'true';
                }
                return this.showTimeStamp;
            },
        },
    };
</script>
